module.exports = __webpack_public_path__ + "cf454f3d3ca1d1b757ebc90dc0896732.jpg";